import React, { useEffect, useState } from "react";
import moment from "moment";
import WhiteContainer from "../../../../shared/white-container";
import Button from "../../../../shared/button";
import { IGuests } from "../../../../interfaces/guests/IGuests";

interface IGuestInfoTab {
  data: IGuests;
  id: string;
}

const GuestInfoTab = ({ data, id }: IGuestInfoTab) => {
  const escapeHtmlString = (htmlString: any) => {
    return htmlString
      .replace(/"/g, '\\"')
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r");
  };

  const onFormatHtml = (text: string) => {
    let htmlText: any;
    try {
      htmlText = escapeHtmlString(text);
      htmlText = JSON.parse(`"${htmlText}"`);
    } catch (error) {
      htmlText = text;
    }
    // const textFormat = htmlText?.replace(/\n/g, '');
    let parser = new DOMParser();
    let doc = parser.parseFromString(htmlText, "text/html");

    let headers = doc.querySelectorAll("h2");

    headers.forEach((header, index: number) => {
      if (header.textContent?.trim().toLowerCase() === "references") {
        let nextElement = header.nextElementSibling;
        if (nextElement && nextElement.tagName.toLowerCase() === "ul") {
          let listItems = nextElement.querySelectorAll("li");
          listItems.forEach((li) => {
            let text = li.textContent?.trim() || "";
            let urlMatch = text.match(/https?:\/\/[^\s]+/g); // Extract URLs
            if (urlMatch) {
              li.innerHTML = urlMatch
                .map(
                  (url) =>
                    `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
                )
                .join(", ");
            }
          });
        }
      }
    });

    return doc.body.innerHTML.replace(/\n/g, "");
  };

  return (
    <WhiteContainer containerStyle="!rounded">
      <div className="flex flex-wrap">
        <div className="w-full md:w-3/12">
          <div className="mb-8">
            <div className="mb-8">
              <img
                src={data?.profileImageUrl || '/png/avatar-icon.png'}
                alt=""
                className="w-full max-h-80 rounded-2xl border"
              />
            </div>
            <h4 className="text-base md:text-xl mb-4">Guest Details</h4>
            <div className="flex flex-row justify-between items-center mb-2  text-sm">
              <p className="text-primary-light">Full Name</p>
              <p>{data?.fullName}</p>
            </div>
            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">Phone</p>
              <p className="text-xs italic">No Available Data</p>
            </div>
            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">Email</p>
              <p className="text-xs italic">No Available Data</p>
            </div>

            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">Check-in</p>
              <p>{moment(data?.bookings[0].checkIn)?.format("MMM DD, YYYY")}</p>
            </div>
            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">Check-out</p>
              <p>
                {moment(data?.bookings[0].checkOut)?.format("MMM DD, YYYY")}
              </p>
            </div>
          </div>
          <div className="mb-8">
            <h4 className="text-base md:text-xl mb-4">Guest Status</h4>
            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">Regular Guest</p>
              <div className="flex items-center mr-1">
                <input
                  checked={data?.status === "regular"}
                  id="checkbox-all-1"
                  data-qa={"checkbox"}
                  type="checkbox"
                  className="w-4 h-4 !outline-none text-blue-600 bg-gray-100 border-gray-300 accent-gray-800 rounded focus:accent-gray-800 focus:ring-2 cursor-normal"
                />
                <label htmlFor="checkbox-all-1" className="sr-only"></label>
              </div>
            </div>
            <div className="flex flex-row justify-between items-center mb-2 text-sm">
              <p className="text-primary-light">VIP Guest</p>
              <div className="flex items-center mr-1">
                <input
                  checked={data?.status === "vip"}
                  id="checkbox-all-1"
                  data-qa={"checkbox"}
                  type="checkbox"
                  className="w-4 h-4 !outline-none text-blue-600 bg-gray-100 border-gray-300 accent-gray-800 rounded focus:accent-gray-800 focus:ring-2 cursor-normal"
                />
                <label htmlFor="checkbox-all-1" className="sr-only"></label>
              </div>
            </div>
            <div className="my-7">
              <h4 className="text-base md:text-xl mb-4">Other Details</h4>
              <div className="flex flex-row justify-between items-center mb-2  text-sm">
                <p className="text-primary-light">Reserved via</p>
                <p className="text-xs italic">No Available Data</p>
              </div>
			  {/* <div className="flex flex-row justify-between items-center mb-2  text-sm">
                <p className="text-primary-light">Past stays</p>
                <p>Stayed {data?.pastStays} times</p>
              </div> */}
			  <div className="flex flex-row justify-between items-center mb-2  text-sm">
                <p className="text-primary-light">Preferred Last Room</p>
                <p>{data?.preferredLastRoom}</p>
              </div>
            </div>
			<div className="my-7">
              <h4 className="text-base md:text-xl mb-4">Past stays</h4>
			  <p className="text-xs italic">No Available Data</p>
            </div>
          </div>
        </div>
		<div className="w-full md:w-9/12 py-3 pl-3 md:pl-20 ">
		{data && <>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Preferences and Interests</h4>
				<p className="text-sm text-[#5D6679]">Hobbies and Interest</p>
				{data.preferences?.hobbies && 
				<ol className="pl-4 list-disc">
					{data.preferences.hobbies.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Likes and Dislikes</h4>
				{data.preferences?.dislikes ? 
				<ol className="pl-4 list-disc">
					{data.preferences.dislikes.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Travel Preferences</h4>
				{(data.preferences?.travelPreferences) ? 
				<ol className="pl-4 list-disc">
					{data.preferences.travelPreferences?.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Leisure Activities</h4>
				{(data.preferences?.leisureActivities) ? 
				<ol className="pl-4 list-disc">
					{data.preferences.leisureActivities?.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Food Preferences</h4>
				{(data.preferences?.foodPreferences) ? 
				<ol className="pl-4 list-disc">
					{data.preferences.foodPreferences?.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Food Preferences</h4>
				{(data.preferences?.beverages) ? 
				<ol className="pl-4 list-disc">
					{data.preferences.beverages?.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">Actionable Insights for Hotel Experience</h4>
				{data.preferences?.actionableInsights ? 
				<ol className="pl-4 list-disc">
					{data.preferences.actionableInsights.map(item => <li className="text-sm text-[#5D6679]">{item}</li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>

			<div className="my-7">
				<h4 className="text-base md:text-xl mb-4">References</h4>
				{data.preferences?.references ? 
				<ol className="pl-4 list-disc">
					{data.preferences.references.map(item => <li className="text-sm text-[#5D6679]"><a rel='noreferrer' href={item} target="_blank" >{item}</a></li>)}
				</ol>
				: <p className="text-xs italic">No Available Data</p>}
            </div>
			</>}
		</div>
      </div>
    </WhiteContainer>
  );
};
export default GuestInfoTab;
